import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface CartRedux {
    itemCount: number,
    coupon_code: string | null,
}


const initialState: CartRedux = {
    itemCount: 0,
    coupon_code: null
}

const cartSlice = createSlice({
    name: 'cart_store',
    initialState,
    reducers: {
        setCartCount: (state, action: PayloadAction<number>) => {
            if (action.payload == 0) {
                state.itemCount = 0
            } else {
                state.itemCount += action.payload
            }

        },

        setCouponCode: (state, action: PayloadAction<string | null>) => {
            state.coupon_code = action.payload;
        },
    }
})

//selectors
export const selectCart = (root: RootState) => root.cart


export const { setCartCount, setCouponCode } = cartSlice.actions;
export default cartSlice.reducer